import { mapGetters } from 'vuex';
import Modal from 'components/Modal/Modal.vue';

export default {
  components: {
    Modal,
  },

  model: {
    prop: 'visible',
    event: 'updateVisibility',
  },

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    ...mapGetters('SettingsModule', [
      'getBetaFeatures',
    ]),

    // when layering multiple `v-model` components, emit events up
    modalVisible: {
      get() {
        return this.visible;
      },

      set(v) {
        this.$emit('updateVisibility', v);
      },
    },
  },

  methods: {
    hideModal() {
      this.$emit('updateVisibility', false);
    },
  },
};
